import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Tournaments = () => {
  const [tournaments, setTournaments] = useState([]);

  useEffect(() => {
    // Fetch tournaments from the API
    axios.get('/api/tournaments').then((response) => {
      setTournaments(response.data);
    });
  }, []);

  return (
    <div>
      <h2>Tournament List</h2>
      <ul>
        {tournaments.map((tournament) => (
          <li key={tournament._id}>{tournament.name}</li>
        ))}
      </ul>
    </div>
  );
};

export default Tournaments;
